import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            enrolmentRegistrationsReceived: 'enrolmentRegistrations/EnrolmentRegistrations',
        }),
        HasAnyEnrolmentRegistrations() { return this.enrolmentRegistrations.length > 0; },
        HasStartedAnyRegistrations() { return this.enrolmentRegistrations.filter(r => r.lastSectionViewed?.length > 0).length > 0; },
        HasCompletedAnyRegistrations() {
            if (this.HasAnyEnrolmentRegistrations) return this.enrolmentRegistrations.filter(r => r.hasCompleted === true).length > 0;
            else return this.HasRegisteredOrCurrentEnrolments;
        },
        HasCompletedAllRegistrations() {
            if (this.HasAnyEnrolmentRegistrations) {
                let enrolmentCount = this.ActiveEnrolments.length;

                this.Connect2Enrolments.forEach(e => {
                    let inductionAttendance = this.inductionAttendances.find(ia => ia.enrolmentID == e.EnrolmentID);

                    if (inductionAttendance?.attending) enrolmentCount++;
                });

                return this.enrolmentRegistrations.filter(r => r.hasCompleted === true).length == enrolmentCount;
            }
            else return !this.HasPreRegisteredEnrolments;
        },
        IsNewEnrolmentRegistration() { return (this.enrolmentRegistration?.id || 0) == 0; },
        IsConnect2Course() { return this.enrolmentRegistration.courseName.indexOf('Connect 2') > -1; },
        IsRegistrationStarted() { return !!this.enrolmentRegistration?.lastSectionViewed; },
        IsRegistrationInProgress() { return !!this.enrolmentRegistration?.lastSectionViewed && !this.enrolmentRegistration?.hasCompleted; },
        IsRegistrationComplete() { return this.enrolmentRegistration?.hasCompleted; },
    },
    methods: {
        ...mapActions({
            FetchEnrolmentRegistrations: 'enrolmentRegistrations/FetchEnrolmentRegistrations',
            FetchEnrolmentRegistration: 'enrolmentRegistrations/FetchEnrolmentRegistration',
            FetchLatestCompletedEnrolmentRegistration: 'enrolmentRegistrations/FetchLatestCompletedEnrolmentRegistration',
            InsertEnrolmentRegistration: 'enrolmentRegistrations/InsertEnrolmentRegistration',
            UpdateEnrolmentRegistration: 'enrolmentRegistrations/UpdateEnrolmentRegistration',
            UpdateEnrolmentRegistrationLastAccessed: 'enrolmentRegistrations/UpdateEnrolmentRegistrationLastAccessed',
        }),
        LoadEnrolmentRegistrations(studentID, academicSession) {
            eventBus.$emit('enrolment-registrations-fetch:started');
            this.FetchEnrolmentRegistrations({ StudentID: studentID, AcademicSession: academicSession })
                .then(response => {
                    if (!!this.enrolmentRegistrationsReceived) this.enrolmentRegistrations = Object.assign([], this.enrolmentRegistrationsReceived);
                    eventBus.$emit('enrolment-registrations-fetch:success', response);
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('enrolment-registrations-fetch:finished'));
        },
        LoadEnrolmentRegistration(enrolment) {
            eventBus.$emit('enrolment-registration-fetch:started');
            this.FetchEnrolmentRegistration({ EnrolmentID: enrolment.EnrolmentID })
                .then(response => eventBus.$emit('enrolment-registration-fetch:success', response))
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('enrolment-registration-fetch:finished'));
        },
        LoadLatestCompletedEnrolmentRegistration(studentID, academicSession) {
            eventBus.$emit('latest-completed-enrolment-registration-fetch:started');
            this.FetchLatestCompletedEnrolmentRegistration({ StudentID: studentID, AcademicSession: academicSession })
                .then(response => eventBus.$emit('latest-completed-enrolment-registration-fetch:success', response))
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('latest-completed-enrolment-registration-fetch:finished'));
        },
        SetBreadcrumb(caption) {
            this.breadcrumbs = [
                { text: 'Home', to: '/', exact: true },
                { text: 'Enrolment Registration' },
                { text: `${this.enrolment.CourseCode} - ${this.enrolment.CourseName}` },
                { text: caption }
            ];
        },
        TranslatePageToPath(title) {
            switch (title) {
                case 'Nationality': return '/nationality';
                case 'Address': return '/address';
                case 'Term-Time Address': return '/term-time-address';
                case 'Contact Information': return '/contact-information';
                case 'Emergency Contact': return '/emergency-contact';
                case 'Fee Payment Method': return '/fee-payment-method';
                case 'Employment Information': return '/employment-information';
                case 'Previous Education': return '/previous-education';
                case 'Care Information': return '/care-information';
                case 'Protected Characteristics': return '/protected-characteristics';
                case 'Disability Information': return '/disability-information';
                case 'Vehicle Information': return '/vehicle-information';
                case 'Graduation Consent': return '/graduation-consent';
                case 'Course Marketing Consent': return '/course-marketing-consent';
                case 'Summary': return '/summary';
                case 'Confirmation': return '/confirmation';
                default: return null;
            }
        },
        Go(path) {
            let fullPath = `/enrolment/${this.enrolmentRegistration.enrolmentID}/${this.enrolmentRegistration.academicSession}/`;
            if (this.enrolmentRegistration.onboardingTypeCode == 'Short') fullPath += 'short/';
            fullPath += path;

            if (this.enrolmentRegistration.hasCompleted) this.$router.push({ path: fullPath });
            else if (this.$refs.form == null || this.$refs.form.validate()) {
                eventBus.$off('enrolment-registration-save:success').$on('enrolment-registration-save:success', () => this.$router.push({ path: fullPath }));
                this.SaveEnrolmentRegistration(this.enrolmentRegistration);
            }
        },
        SaveEnrolmentRegistration() {
            var message = { Payload: this.enrolmentRegistration };

            if (this.IsNewEnrolmentRegistration) {
                eventBus.$emit('enrolment-registration-save:started');
                this.InsertEnrolmentRegistration(message)
                    .then(response => {
                        this.enrolmentRegistration.id = parseInt(response.id);
                        eventBus.$emit('alert:success', response);
                        eventBus.$emit('enrolment-registration-save:success');
                    })
                    .catch(error => eventBus.$emit('enrolment-registration-save:failed', error))
                    .finally(() => eventBus.$emit('enrolment-registration-save:finished'));
            }
            else {
                eventBus.$emit('enrolment-registration-save:started');
                this.UpdateEnrolmentRegistration(message)
                    .then(response => {
                        eventBus.$emit('alert:success', response);
                        eventBus.$emit('enrolment-registration-save:success');
                    })
                    .catch(error => eventBus.$emit('enrolment-registration-save:failed', error))
                    .finally(() => eventBus.$emit('enrolment-registration-save:finished'));
            }
        },
        UpdateLastAccessed() {
            eventBus.$emit('enrolment-registration-last-accessed:started');
            this.UpdateEnrolmentRegistrationLastAccessed({
                EnrolmentID: this.enrolmentRegistration.enrolmentID,
                LastSectionViewed: this.enrolmentRegistration.lastSectionViewed
            })
                .then(() => eventBus.$emit('enrolment-registration-last-accessed:success'))
                .catch(error => eventBus.$emit('enrolment-registration-last-accessed:failed', error))
                .finally(() => eventBus.$emit('enrolment-registration-last-accessed:finished'));
        },
        ConfirmCancel() {
            if (this.enrolmentRegistration.hasCompleted) this.$router.push({ path: '/' });
            else {
                eventBus.$off('cancel-registration:ok').$on('cancel-registration:ok', () => this.Cancel());
                eventBus.$emit('cancel-registration:show');
            }
        },
        Cancel() {
            eventBus.$off('enrolment-registration-save:success').$on('enrolment-registration-save:success', () => this.$router.push({ path: '/' }));
            this.SaveEnrolmentRegistration(this.enrolmentRegistration);
        }
    },
};